import React from 'react';
import { Link } from 'react-scroll';

const Hero = () => {
  return (
    <section className="hero" id="hero">
      <div className="container">
        <div className="hero-content">
          <h1>Przekształcamy Twoje Pomysły w gotowe projekty</h1>
          <p>
            Specjalizujemy się w pisaniu wniosków grantowych, biznesplanów 
            i kompleksowym doradztwie. Nasze doświadczenie to Twój sukces.
          </p>
          
          <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
            <Link 
              to="contact" 
              spy={true} 
              smooth={true} 
              offset={-70} 
              duration={500} 
              className="btn btn-primary"
              aria-label="Skontaktuj się z nami w sprawie swojego projektu"
            >
              <i className="fas fa-rocket"></i>
              Rozpocznij współpracę
            </Link>
            
            <Link 
              to="services" 
              spy={true} 
              smooth={true} 
              offset={-70} 
              duration={500} 
              className="btn btn-outline"
              style={{ color: 'white', borderColor: 'white' }}
            >
              <i className="fas fa-info-circle"></i>
              Zobacz usługi
            </Link>
          </div>

          <div className="hero-stats">
            <div className="hero-stat">
              <span className="hero-stat-number">50+</span>
              <span className="hero-stat-label">Uzyskanych dotacji</span>
            </div>
            <div className="hero-stat">
              <span className="hero-stat-number">5M+</span>
              <span className="hero-stat-label">PLN pozyskanych środków</span>
            </div>
            <div className="hero-stat">
              <span className="hero-stat-number">10+</span>
              <span className="hero-stat-label">Lat doświadczenia w pisaniu grantów</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
